module.exports = __webpack_public_path__ + "static/digipartner-logo-5015ea15c9aa5af424d5eaf5d48b261e.png";